export { default as Acceptance } from './Acceptance';
export { default as CommercialInformation } from './CommercialInformation';
export { default as Documentation } from './Documentation';
export { default as Operation } from './Operation';
export { default as Services } from './Services';

export const datePickerStyles = { minWidth: '180px' };
